import { companyService } from 'hq/services';
import { useQuery } from 'react-query';
import { CACHE_TIME_LONG } from 'shared/react-query/query-defaults';
import { QUERY_KEYS } from 'api/query-keys';

export const useGetOrts = (companyId: string) => {
  const queryFn = async () => await companyService.getOrts(companyId);

  return useQuery(QUERY_KEYS.orts(), queryFn, {
    cacheTime: CACHE_TIME_LONG,
  });
};
